function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import styled, { ThemeContext, css } from 'styled-components';
import Text from "../../Typography/Text";
import { formatWeightToCommaSeparated, getPackWeightWithoutPrefix, calcPrice } from "../helpers";
import { EnumProductType } from "../types";
import colors from "../../../colors/index";
var StyledText = styled(Text).withConfig({
  displayName: "UnitInfo__StyledText",
  componentId: "sc-1gt8qcv-0"
})(["font-size:12px !important;line-height:16px !important;color:", ";", ";"], colors.blackRussian06, function (_ref) {
  var isKomus = _ref.isKomus;

  if (isKomus) {
    return css(["color:", " !important;font-size:14px !important;"], colors.dark200);
  }
});

var UnitInfo = function UnitInfo(_ref2) {
  var _EnumProductType$pack;

  var displayWeight = _ref2.displayWeight,
      productType = _ref2.productType,
      pricePerUnit = _ref2.pricePerUnit,
      _ref2$hidePricePerUni = _ref2.hidePricePerUnit,
      hidePricePerUnit = _ref2$hidePricePerUni === void 0 ? true : _ref2$hidePricePerUni,
      unit = _ref2.unit,
      isKomus = _ref2.isKomus;

  var _calcPrice = calcPrice(pricePerUnit),
      priceInt = _calcPrice.priceInt,
      priceFract = _calcPrice.priceFract;

  var _useContext = useContext(ThemeContext),
      priceSign = _useContext.priceSign;

  return React.createElement(StyledText, {
    isKomus: isKomus
  }, (_EnumProductType$pack = {}, _defineProperty(_EnumProductType$pack, EnumProductType.pack, formatWeightToCommaSeparated(getPackWeightWithoutPrefix(displayWeight))), _defineProperty(_EnumProductType$pack, EnumProductType.weight, Number.isNaN(parseFloat(displayWeight)) ? '1 кг' : formatWeightToCommaSeparated(displayWeight)), _defineProperty(_EnumProductType$pack, EnumProductType.piece, formatWeightToCommaSeparated(displayWeight)), _EnumProductType$pack)[productType], !hidePricePerUnit && React.createElement(React.Fragment, null, React.createElement(Text, {
    fontWeight: "600"
  }, "\xA0\xB7\xA0"), priceInt, ",", priceFract, "\xA0", priceSign, "/", unit));
};

export default UnitInfo;